export default __webpack_public_path__ + "static/media/Level2.4d3cb300.svg";